import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {BicBadgeComponent, TooltipDirective} from '@buildinginformationcloud/bic-ui-components';
import {ReportRow} from './report-row.model';

/**
 * myChecks eines Berichts als Badge: erster myCheck-Name plus „+N“ im selben Badge. Der dunkle
 * Tooltip listet alle myChecks mit Prüftyp (Figma „Tooltip – myChecks“).
 *
 * Läufe ohne Namensliste (Alt-Checks, Läufe vor #2541 ohne Backfill) zeigen nur die Anzahl, ohne
 * Tooltip – es gibt dann nichts aufzulisten.
 */
@Component({
  selector: 'app-report-mychecks-badge',
  templateUrl: './report-mychecks-badge.component.html',
  imports: [BicBadgeComponent, TooltipDirective],
  // bic-badge schrumpft von sich aus nicht unter die Textbreite – ein langer myCheck-Name liefe
  // sonst aus Karte bzw. Tabellenzelle heraus. Host, Badge und innerer Chip duerfen deshalb
  // schmaler werden, der Name wird per `truncate` gekuerzt.
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    :host {
      display: flex;
      min-width: 0;
      max-width: 100%;
    }

    bic-badge {
      display: flex;
      min-width: 0;
      max-width: 100%;
    }

    :host ::ng-deep bic-badge > div {
      min-width: 0;
      max-width: 100%;
      overflow: hidden;
    }
  `,
})
export class ReportMyChecksBadgeComponent {
  @Input({required: true}) row!: ReportRow;

  /** Breite der Tooltip-Blase laut Figma (272 px Inhalt + Innenabstand). */
  protected readonly tooltipWidth = 296;

  get title(): string {
    const count = this.row.myChecks.length;
    return count === 1 ? '1 myCheck' : `${count} myChecks`;
  }
}
